<script setup>
import {defineProps, defineEmits, computed} from 'vue';
import DpIcon from "./DpIcon";
import DpExpand from "./DpExpand";
import {isEmpty} from 'lodash';

const props = defineProps({
  visibility: {type: Boolean, default: true},
  type: {type: String, default: 'info'},
  title: {type: String},
  message: {type: String, default: undefined}
})
const emit = defineEmits(['update:visible']);
const icon = computed(() => {
  const icon = {
    'danger': 'close',
    'error': 'close',
    'warning': 'close',
    'success': 'check',
    'info': 'info'
  };
  return icon[props.type];
});
</script>
<script>
export default {
  name: "DpNotification"
}
</script>

<template>
  <DpExpand>
    <div v-show="visibility"
         :class="[
        'dp-notification',
        props.type
      ]">
      <div v-if="!isEmpty(props.title)" class="dp-flex row">
        <h4 class="overwrite-element-plus-rule"><DpIcon :icon="icon" /></h4>
        <h4 class="overwrite-element-plus-rule"><slot name="title">{{ title }}</slot></h4>
      </div>
      <div>
        <slot>{{ props.message }}</slot>
      </div>
      <div>
        <slot name="controls"></slot>
      </div>
    </div>
  </DpExpand>
</template>

<style scoped lang="scss">
.dp-notification {
  border-radius: 8px;
  padding: 1em;
  margin: 1em 0;

  &.danger {
    background-color: var(--use-theme__event__danger__background-color);
    color: var(--use-theme__event__danger__font-color);
  }
  &.error {
    background-color: var(--use-theme__event__error__background-color);
    color: var(--use-theme__event__error__font-color);
  }
  &.warning {
    background-color: var(--use-theme__event__warning__background-color);
    color: var(--use-theme__event__warning__font-color);
  }
  &.success {
    background-color: var(--use-theme__event__success__background-color);
    color: var(--use-theme__event__success__font-color);
  }
  &.info {
    background-color: var(--use-theme__event__info__background-color);
    color: var(--use-theme__event__info__font-color);
  }

  .overwrite-element-plus-rule { // TODO: Remove this rule when element plus is removed.
    color: inherit;
  }
}
</style>

<i18n>
{}
</i18n>

